import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import { RouterProvider } from 'react-router-dom'
import { routes } from './routes'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ToastContainer, Zoom } from 'react-toastify'
import { AuthProvider } from 'context/authContext'
import 'styles/globals.scss'
import { Provider } from 'react-redux'
import { persistor, store } from 'store/redux'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { PostHogProvider } from 'posthog-js/react'
import posthog from 'posthog-js'
import { PersistGate } from 'redux-persist/integration/react'
const options = {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    // Anonymous browsing stays cheap; a person profile is created on identify()
    // (after login), which back-links the pre-login events into that person.
    person_profiles: 'identified_only' as const,
    // Capture the initial pageview automatically. SPA route changes are captured
    // manually below (posthog-js < 1.160 does not auto-capture history changes).
    capture_pageview: true,
    capture_pageleave: true,
}

// posthog-js 1.147 only fires $pageview on the initial hard load, so client-side
// navigations (React Router) go untracked. Emit a $pageview whenever the path
// changes so page-based funnels and path analytics see the full journey.
let lastTrackedPath = window.location.pathname
routes.subscribe((state) => {
    const path = state.location.pathname
    if (path !== lastTrackedPath) {
        lastTrackedPath = path
        posthog.capture('$pageview')
    }
})
const queryClient = new QueryClient({
    defaultOptions: {
        mutations: {
            retry: false,
        },
        queries: {
            refetchOnWindowFocus: true,
            retry: false,
        },
    },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <PostHogProvider
                    apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
                    options={options}
                >
                    <QueryClientProvider client={queryClient}>
                        <AuthProvider>
                            <RouterProvider router={routes} />
                            <ToastContainer
                                position="top-center"
                                className="text-right"
                                transition={Zoom}
                                hideProgressBar={true}
                            />
                        </AuthProvider>
                    </QueryClientProvider>
                </PostHogProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>
)
// Activate a newly deployed version instead of sitting on the old one.
//
// register() used to be called with no config, so onUpdate did nothing: the new
// service worker installed and then stayed in `waiting` forever. Reloading did
// NOT help -- a waiting worker only takes over once every tab of the origin is
// closed -- so a deploy was invisible to anyone with the app already open.
// service-worker.ts already listens for SKIP_WAITING; nothing ever sent it.
//
// onUpdate only fires when a controller already exists (i.e. a real update, not
// the first install), so this cannot loop on a fresh visit. The `reloaded`
// guard keeps controllerchange from reloading more than once.
serviceWorkerRegistration.register({
    onUpdate: (registration) => {
        const waiting = registration.waiting
        if (!waiting) return

        let reloaded = false
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (reloaded) return
            reloaded = true
            window.location.reload()
        })

        waiting.postMessage({ type: 'SKIP_WAITING' })
    },
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
//fucking test
//fucking test 2
